/**
 * MM Trial Box – cart controls
 *
 * A Trial Box is a set of sachet line items sharing one `_mm_trial_box` group id.
 * The cart renders them as a single locked bundle (see snippets/mm-trial-box-group.liquid),
 * so the only action is removing the whole box — which means zeroing every sachet line in
 * one request rather than following the per-line `url_to_remove`.
 *
 * The listener is delegated from `document` because the cart drawer replaces its own
 * innerHTML on every cart change; binding to the buttons directly would not survive that.
 */
(function () {
  'use strict';

  /** Locale-aware root path, e.g. "/" or "/en-za/" */
  function routeRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function removeBox(button) {
    var keys = (button.getAttribute('data-mm-box-keys') || '')
      .split(',')
      .filter(function (key) {
        return key.length > 0;
      });

    if (keys.length === 0) return;

    var updates = {};
    keys.forEach(function (key) {
      updates[key] = 0;
    });

    /* Mirror the theme's own quantity-change flow: ask which sections need re-rendering,
       then request them in the same round trip so the drawer swaps in fresh markup. */
    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle }
      })
    );

    button.setAttribute('aria-busy', 'true');
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

    fetch(routeRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        updates: updates,
        sections: sectionsToBundle.join(',')
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart update failed');
        return response.json();
      })
      .then(function (cart) {
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));

        /* On the cart page the theme reloads after any quantity change, so the totals,
           free-shipping bar and footer all stay consistent. Match that. */
        if (window.themeVariables && window.themeVariables.settings.pageType === 'cart') {
          window.location.reload();
          return;
        }

        /* baseEvent 'line-item:change' re-renders the drawer contents without re-opening it
           — 'variant:add' is what triggers the open. */
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'line-item:change', cart: cart }
          })
        );
      })
      .catch(function (error) {
        console.error('MM Trial Box remove error:', error);
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
        button.removeAttribute('aria-busy');
        window.location.reload();
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.mm-box__remove');
    if (!button || button.hasAttribute('aria-busy')) return;

    event.preventDefault();
    removeBox(button);
  });
})();
